import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { useApi, useLoad } from "@/lib/api";
import { Panel, Table } from "@/pages/console/Kit";

const STAGES = ["new", "contacted", "visited", "started", "abandoned", "signed_up", "lost"];

export default function Leads() {
  const api = useApi();
  const l = useLoad("/admin/leads");
  const [csv, setCsv] = useState("company name,company number,company type,branches,region,email\n");
  const [campaign, setCampaign] = useState("");
  const patch = async (id, body) => { try { await api("patch", `/admin/leads/${id}`, body); l.reload(); } catch (e) { toast.error(e.message); } };
  const imp = async () => { try { const r = await api("post", "/admin/leads/import", { csv, campaign }); toast.success(`${r.imported} leads imported`); l.reload(); } catch (e) { toast.error(e.message); } };
  return (
    <div className="space-y-6">
      <Panel title="Import leads" testid="leads-import">
        <Textarea rows={4} value={csv} onChange={(e) => setCsv(e.target.value)} className="font-mono text-xs" data-testid="leads-csv-input" />
        <div className="mt-3 flex gap-2"><Input className="w-56" placeholder="Campaign" value={campaign} onChange={(e) => setCampaign(e.target.value)} /><Button onClick={imp} data-testid="leads-import-button">Import</Button></div>
      </Panel>
      <Panel title="Pipeline">
        <Table testid="leads-table" rows={l.data || []} cols={[
          ["company", "Company"], ["company_number", "Company no."], ["company_type", "Type"], ["branches", "Branches"], ["email", "Email"],
          ["stage", "Stage", (r) => <select value={r.stage} onChange={(e) => patch(r.id, { stage: e.target.value })} className="h-8 rounded-md border bg-white px-1 text-xs" data-testid={`lead-stage-${r.id}`}>{STAGES.map((s) => <option key={s}>{s}</option>)}</select>],
          ["consent", "Consent", (r) => <input type="checkbox" checked={!!r.consent} onChange={(e) => patch(r.id, { consent: e.target.checked })} />],
          ["suppressed", "Unsubscribed", (r) => <input type="checkbox" checked={!!r.suppressed} onChange={(e) => patch(r.id, { suppressed: e.target.checked })} />]]} />
      </Panel>
    </div>
  );
}
